import { z } from 'zod';
import { isProducerCheckinItem } from 'utils/KnockFeedUtils';
/**
 * Who the banner says is speaking (SCO-492). Pure view-state, following the
 * `nudgeButtonView` / `bannerAvatarView` convention.
 *
 * The three producer-facing workflows carry genuinely different payloads, so
 * the banner cannot assume a coach is behind every message:
 *
 * - `coach-nudge` — a human pressed the button. `coach_name` + coach avatar.
 * - `producer-nudge` — the AI wrote it. Coach avatar, but no name, because
 *   naming a coach who did not choose these words would be a lie.
 * - `producer-morning-checkin` — no coach in the payload at ALL (no
 *   `coach_avatar_url`), and rightly so: the system is asking, not a person.
 */
var CoachNudgeIdentity = z.object({
    coach_name: z.string().min(1),
    coach_avatar_url: z.string().nullable().optional()
});
var CoachAvatarOnly = z.object({
    coach_avatar_url: z.string().nullable().optional()
});
export var bannerIdentity = function (item) {
    var _a, _b;
    if (isProducerCheckinItem(item)) {
        return { label: 'Morning check-in', avatarUrl: null };
    }
    var named = CoachNudgeIdentity.safeParse(item.data);
    if (named.success) {
        return {
            label: named.data.coach_name,
            avatarUrl: (_a = named.data.coach_avatar_url) !== null && _a !== void 0 ? _a : null
        };
    }
    var avatar = CoachAvatarOnly.safeParse(item.data);
    return {
        label: 'Your coach',
        avatarUrl: avatar.success ? (_b = avatar.data.coach_avatar_url) !== null && _b !== void 0 ? _b : null : null
    };
};
